export default {
  SET_BROKEN_LINKS: function (state, payloads) {
    state.brokenLinks = payloads;
  },
}
